import type { CreateTypePropertyInput } from '@idc-forms/schemas'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateTypePropertyMutation } from '../hooks/use-type-property-mutations'
import { TypePropertyForm } from './type-property-form'

type TypePropertyCreatePanelProps = {
  onDone?: () => void
}

/** "Nuevo subtipo" dentro del side panel: el mismo TypePropertyForm que la edición. */
export function TypePropertyCreatePanel({ onDone }: TypePropertyCreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateTypePropertyMutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: CreateTypePropertyInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <TypePropertyForm
      submitLabel="Crear subtipo"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
